// extracted by mini-css-extract-plugin
export default {"root":"FavoriteButton_root__17Akw","icon":"FavoriteButton_icon__fLSdN","bookmarked":"FavoriteButton_bookmarked__8-G6V"};